var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21,
    r: 1,
    transform: "rotate(-180 12 21)",
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 21,
    r: 1,
    transform: "rotate(-180 15.5 21)",
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 1,
    transform: "rotate(-180 19 21)",
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 21,
    r: 1,
    transform: "rotate(-180 8.5 21)",
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 21,
    r: 1,
    transform: "rotate(-180 5 21)",
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 1,
    transform: "rotate(-180 5 17)",
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 13,
    r: 1,
    transform: "rotate(-180 5 13)",
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 1,
    transform: "rotate(-180 19 17)",
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 13,
    r: 1,
    transform: "rotate(-180 19 13)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14V4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2426 7.00045L12 2.75781L7.75736 7.00045",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0a596989619a280cbfac67ba61689f8d.svg";
export { ForwardRef as ReactComponent };